import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Form } from 'informed';
import axios from 'axios';
import { API_HOST } from '../../../consts';
import InputSelect from '../../../components/inputs/InputSelect';
import { toast } from 'react-toastify';
import { FilterRelatorioContext } from '../../../contexts/FilterRelatorioProvider/Context';
import { Grid, Typography } from '@material-ui/core';
import { withTheme } from 'styled-components';
import { Link } from 'react-router-dom';
import { get } from 'lodash';

const FORM_INITIAL_STATE = {
  dreOptions: null,
  municipioOption: '-',
  escolaOptions: null,
  ano: null,
  periodo: null,
  etapaOptions: null,
  turmaOptions: null,
  disciplinaOptions: null
};

const FiltersPageStudentAvaliaMt = ({ buttonRelatorio, setBoletimData, ...props }) => {
  const { setStateFilters } = useContext(FilterRelatorioContext);
  const [formInputData, setFormInputData] = useState({});
  const [state, setState] = useState({
    me: null,
    loadingForm: false,
    isLoadingAlunos: false,
    isLoading: false,
    isPlaceholder: 'Selecione',
  });
  const [formApi, setFormApi] = useState(null);
  const [inputSearch, setInputSearch] = useState('');
  const [selectedButton, setSelectedButton] = useState(null);
  const [formData, setFormData] = useState(FORM_INITIAL_STATE);

  const groups =
    state.me &&
    state.me.logged_group.map((f) => {
      return f.toUpperCase();
    });

  const host = window.location.host
  const legenda ='Rede de Ensino';
  const restrictAcess = (groups && groups.includes('ADMINISTRADOR')) || (groups && groups.includes('DRE'));
  const mustShowAllButton = inputSearch.length === 0 ? false : true;
  const urlParams = new URLSearchParams(window.location.search);
  const idn = urlParams.get('idn');
  const periodoAno = urlParams.get('periodoAno');


  const performUpdate = (newData) => {
    setFormInputData((prevState) => ({ ...prevState, ...newData }))
  }

  const stepsWithSelectedAluno = async () => {
    setState((prevState) => {
      return { ...prevState, loadingForm: true };
    })
    const {
      PERIODO_ANO_ID: periodo,
      disciplinaOptions,
      etapaOptions,
      turmaOptions,
      dreOptions,
      student,
      municipioOption,
      escolaOptions,
      ano
    } = await fectchAlunoData(idn, periodoAno);
    setFormData({
      dreOptions: dreOptions.name,
      municipioOption: municipioOption,
      escolaOptions: escolaOptions,
      ano: ano.value,
      periodo: periodo,
      etapaOptions: etapaOptions.numero,
      turmaOptions: turmaOptions,
      disciplinaOptions: disciplinaOptions,
    });

    performUpdate({ escolaId: escolaOptions, ano: ano.value, provas: periodo, periodoAno: periodo });
    performUpdate({ provas: periodo, ano: periodo });
    await fetchAno();
    await fetchMe();
    await fetchDre();
    await fetchMunicipio(dreOptions);
    await fetchEscola({ value: municipioOption });
    await fetchEtapaEscola({ cd_escola: escolaOptions });
    await fetchPeriodo();
    await fetchAnoPeriodo(periodo, ano.value);
    await fetchTurma('None', { escolaOptions, cd_etapa: etapaOptions.avaliamt_etapa, nr_etapa: etapaOptions.numero, periodo });
    await fetchDisciplinas({ cd_escola: escolaOptions, cd_turma: turmaOptions });
    setStateFilters({ periodoAno: periodo })
    handleClickButtonStudent(idn, student, periodo);
    await fetchAlunos({
      ano: ano.value,
      etapaOptions: etapaOptions.numero,
      disciplinaOptions: disciplinaOptions,
      periodoAno: periodo,
      currentEscola: escolaOptions,
      cd_turma: turmaOptions,
    });
    setState((prevState) => {
      return { ...prevState, loadingForm: false };
    })
  }

  useEffect(() => {
    const mountWithSelectedAluno = async () => {
      await stepsWithSelectedAluno();
    }
    const mountWithoutSelectedAluno = async () => {
      setState((prevState) => {
        return { ...prevState, loadingForm: true };
      })
      await fetchAno();
      await fetchMe();
      await fetchDre();
      setState((prevState) => {
        return { ...prevState, loadingForm: false };
      })
    }
    if (idn) {
      mountWithSelectedAluno();
    } else {
      mountWithoutSelectedAluno();
    }
  }, []);

  useEffect(() => {
    if (formApi && formInputData.periodoAno) {
      fetchEtapaFiltered();
    }
  }, [formInputData.periodoAno]);

  const alunoData = (d) => ({
    value: d.id,
    label: d.nm_aluno,
    cd_inst: d.cd_institucional_aluno,
    etapa: d.dc_etapa,
    prova: d.prova_a_prova_ds,
    ...d
  });

  const fectchAlunoData = async (idn) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/boletim_mt/${idn}/get_aluno_simple_data?periodo_ano=${periodoAno}`);
      return response.data;
    } catch (error) {
      toast.error("Nenhum estudante encontrado");
      console.error(error.message);
    }
  }

  const fetchDre = async () => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/dre`)
      performUpdate({
        dreOptions: response && response.data.map((d) => ({
          id: d.external_id,
          value: d.external_id,
          label: removeAccents(d.dre_name),
          ...d
        }))
      })
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const removeAccents = (str) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  const fetchMunicipio = async (dreId) => {
    if (dreId) {
      try {
        performUpdate({ dreId: dreId.id })
        const response = await axios.get(`${API_HOST}/avalia/municipio?dre_id=${dreId.id}`)
        if (response.data.results.length === 0) {
          throw new Error('Nenhum município encontrado');
        }
        performUpdate({
          municipioOption: response && response.data.results.map((d) => ({
            value: d.cd_municipio,
            label: d.nm_municipio,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhum município encontrado");
        console.error(error.message);
      }
    };
  }

  const fetchEscola = async (municipio) => {
    if (municipio) {
      try {
        const params = {
          cd_municipio: municipio.value
        }
        const response = await axios.get(`${API_HOST}/avalia/escola`, {params})
        if (response.data.length === 0) {
          throw new Error('Nenhuma escola encontrada');
        }
        performUpdate({
          escolaOptions: response && response.data.map((d) => ({
            value: d.cd_escola,
            label: d.nm_escola,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhuma escola encontrada");
        console.error(error.message);
      }
    };
  }

  const fetchEtapaEscola = async (cdEscola) => {
    if (cdEscola) {
      try {
        const response = await axios.get(`${API_HOST}/avalia/escola_etapa?cd_escola=${cdEscola.value}`)
        if (response.data.results.length === 0) {
          throw new Error('Nenhuma etapa encontrada');
        }
        performUpdate({
          etapaOption: response && response.data.results.map((d) => ({
            value: d.nr_etapa,
            label: d.dc_etapa,
            ...d
          }))
        });
      } catch (error) {
        // toast.error("Nenhuma etapa encontrada"); #to do validar se faz sentido essa validação em algum contexto
        console.error(error.message);
      }
    }
  }

  const fetchEtapaFiltered = async () => {
    const { periodo, escolaOptions } = formApi.getState().values;
    const params = {
      dre_id: formInputData.dreId,
      periodo_ano_id: formInputData.periodoAno,
      escolaOptions: escolaOptions
    }
    try {
      const response = await axios.get(`${API_HOST}/avalia/etapa-input`, { params })
      const data = response.data.map((d) => ({ value: d.nr_etapa, label: d.etapa, ...d }));
      performUpdate({ etapaOption: data });
    } catch (error) {
      toast.error(error);
    };

  };

  const fetchAno = async () => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/ano`);
      performUpdate({
        anoOptions: response.data.map((d) => ({
          value: d.id,
          label: d.ds_ano
        }))
      });
    } catch (error) {
      toast.error("Nenhum ano encontrado");
      console.error(error.message);
    }
  };

  const fetchPeriodo = async () => {
    setState(prevState => ({ ...prevState, isLoading: true }));
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo`);
      performUpdate({
        periodoOptions: response && response.data.map((d) => ({
          value: d.id,
          label: d.ds_periodo
        }))
      });
      setState(prevState => ({ ...prevState, isLoading: false }));
    } catch (error) {
      toast.error("Nenhum período encontrado");
      console.error(error.message);
    }
  };

  const fetchAnoPeriodo = async (periodo, ano) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo_ano?periodo__id=${periodo}&ano__id=${ano}`);
      if (response.data.length > 0) {
        performUpdate({ periodoAno: response.data[0].id });
      } else {
        toast.error('Nenhum período de ano encontrado');
      }
    } catch (error) {
      toast.error("Nenhuma prova encontrada");
      console.error(error.message);
    }
  };
  const fetchAnoPeriodoByid = async (periodoano) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/periodo_ano?id=${periodoano}`);
      if (response.data.length > 0) {
        performUpdate({ periodoAno: response.data[0].id });
      } else {
        toast.error('Nenhum período de ano encontrado');
      }
    } catch (error) {
      toast.error("Nenhuma prova encontrada");
      console.error(error.message);
    }
  };

  const fetchTurma = async (escolaId, values) => {
    const {periodoAno} = formInputData
    const {
      nr_etapa,
      cd_etapa,
      escolaOptions: cd_escola,
    } = values ? values : { ...formApi.getState().values, ...escolaId };

    if (escolaId) {
      performUpdate({ currentEscola: cd_escola, nrEtapa: nr_etapa, codigoEtapa: cd_etapa });
      try {
        const response = await axios.get(
          `${API_HOST}/avalia/turma?cd_escola=${cd_escola}&cd_etapa=${cd_etapa}&periodo_ano_id=${periodoAno}`
        );
        performUpdate({
          turmaOptions: response && response.data.results.map((d) => ({
            value: d.cd_turma,
            label: '(' + d.nm_turma + ') ' + d.cd_turma,
            ...d
          }))
        });
      } catch (error) {
        toast.error("Nenhuma turma encontrada");
        console.error(error.message);
      }
    }
  };

  const fetchDisciplinas = async (disciplina) => {
    try {
      const response = await axios.get(`${API_HOST}/avalia/disciplina`);
      performUpdate({
        disciplinaOptions: response.data.results.map((d) => ({
          value: d.id,
          label: d.disciplina,
          ...d
        })),
        cd_turma: disciplina.cd_turma,
        currentEscola: disciplina.cd_escola
      })
    } catch (error) {
      toast.error("Nenhuma disciplina encontrada");
      console.error(error.message);
    }
  };

  const fetchAlunos = async (values) => {
    setState((prevState) => {
      return { ...prevState, isLoadingAlunos: true };
    })
    performUpdate({ alunoOptions: [] })
    const { periodoAno, ano, currentEscola, cd_turma } = values ? values : formInputData;
    const { disciplinaOptions, etapaOptions } = values ? values : formApi.getState().values;
    await fetchAnoPeriodoByid(periodoAno);
    !values && setStateFilters({ fecth: false })
    if (periodoAno && ano) {
      try {
        const response = await axios.get(`${API_HOST}/avalia/estudante/get_period_student?cd_escola=${currentEscola}&cd_turma=${cd_turma}&prova_a_cd_disciplina=${disciplinaOptions}&nr_etapa=${etapaOptions}&periodo_ano_id=${periodoAno}`)
        performUpdate({ alunoOptions: response.data.map(alunoData) })
        if (response.data.length === 0) {
          throw new Error('Nenhum aluno encontrado');
        }
        !values && setBoletimData({});
      } catch (error) {
        setStateFilters({ fecth: false })
        performUpdate({ alunoOptions: [] })
        setBoletimData({});
        toast.error(`Nenhum estudante encontrado para a busca selecionada.`);
        console.error(error.message);
      }
    }
    setState((prevState) => {
      return { ...prevState, isLoadingAlunos: false };
    })
  }

  const fetchDres = async (me) => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/core/rede_dre_inst/${me}/get_dres`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      performUpdate({
        dres: get(response.data,'dre').map((d) => ({
          ...d,
          id: d.cd_dre,
          value: d.ds_dre,
          label: d.ds_dre
        }))
      });
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const fetchDresAdm = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/avalia/dre`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      performUpdate({
        dres: response.data.map((d) => ({
          ...d,
          id: d.external_id,
          value: removeAccents(d.dre_name),
          label: d.dre_name,
        }))
      });
    } catch (error) {
      toast.error("Nenhum DRE encontrado");
      console.error(error.message);
    }
  };

  const fetchInstitution = async (me, dre) => {
    const token = localStorage.getItem('token');
    try {
      performUpdate({ dreId: dre })
      const response = await axios.get(
        `${API_HOST}/core/rede_dre_inst/get_escolas?user_group_instituicao__usuario=${me}&dre__cd_dre=${dre}`,
        {
          headers: {
            Authorization: `JWT ${token}`
          }
        }
      );
      if (response.data.length === 0) {
        throw new Error('Nenhuma escola encontrada');
      }
      performUpdate({
        escolaOptions: response.data.map((x) => ({
          id: x.instituicao.instituicao.id,
          value: x.instituicao.instituicao.codigo,
          label: x.instituicao.instituicao.descricao
        }))
      });
    } catch (error) {
      setState(prevState => ({ ...prevState, isLoading: false }));
      toast.error("Nenhuma escola encontrada");
      console.error(error.message);
    }
  }

  const fetchMe = async () => {
    const token = localStorage.getItem('token');
    try {
      const response = await axios.get(`${API_HOST}/login/me`, {
        headers: {
          Authorization: `JWT ${token}`
        }
      });
      setState(prevState => ({ ...prevState, me: response.data }));
      let groups = response.data.logged_group.map((f) => {
        return f.toUpperCase();
      });
      if (groups.includes('ADMINISTRADOR')) {
        fetchDresAdm();
      } else {
        fetchDres(response.data.id);
      }
    } catch (error) {
      toast.error("Dados de acesso não encontrados");
      console.error(error.message);
    }
  }

  const isValidForm = () => {
    let isValidForm = true;
    let formValues = formApi.getState().values;
    Object.keys(formValues).forEach((key) => {
      if (!isValidField(formValues[key])) {
        formApi.setError(key, ['O campo é obrigatório']);
        isValidForm = false;
      }
    });
    return isValidForm;
  }

  const submitForm = (e) => {
    e.preventDefault()
    if (isValidForm()) {
      setStateFilters({ ...formInputData });
      setInputSearch('');
      setSelectedButton(null);
      fetchAlunos();
    }
  }

  const isValidField = fieldValue => {
    if (fieldValue === null || fieldValue === undefined || fieldValue === '') {
      return false;
    }
    return true;
  };

  const handleClickButtonStudent = (idn, student, periodoAno) => {
    if (!periodoAno)
      periodoAno = formInputData.periodoAno;
    buttonRelatorio(idn, periodoAno);
    setSelectedButton(idn)
    setInputSearch(student);
  }

  const isSelectedButton = (idn) => {
    if (Number(idn) === Number(selectedButton))
      return true;
    return false;
  }

  return (
    <>
      {state.loadingForm ? (
        <div
          style={{
            width: '100%',
            height: `100%`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <img src={get(props.theme, "loadingGif")} alt="loading" style={{ height: '50px' }} />
        </div>) : (
        <div>
          <Form
            key={`form-${FORM_INITIAL_STATE.dreOptions}`}
            getApi={(formApi) => {
              setFormApi(formApi);
            }}
            initialValues={formData}
          >
            <Grid
              container
              style={{
                ...(!restrictAcess && { justifyContent: 'flex-end' })
              }}>
              <Grid item xs={12} md={3}>
                <InputSelect
                  key='dreOptions-select'
                  label={legenda}
                  field='dreOptions'
                  onChange={(e) => {
                    if(restrictAcess){
                      formApi.setValue('municipioOption', '');
                      fetchMunicipio(e)
                    } else {
                      formApi.setValue('escolaOptions', '');
                      fetchInstitution(state.me.id, e.id)
                    }
                  }}
                  options={formInputData.dres}
                  required={restrictAcess ? true : false}
                />
              </Grid>

              {restrictAcess &&
                <Grid item xs={12} md={3}>
                  <InputSelect
                    key={'municipioOption-select'}
                    label='Município'
                    field='municipioOption'
                    onChange={(e) => {
                      formApi.setValue('escolaOptions', '');
                      fetchEscola(e)
                    }}
                    options={formInputData.municipioOption}
                    required={true}
                  />
                </Grid>}

              <Grid item xs={6}>
                <InputSelect
                  key={'escolaOptions-select'}
                  label='Escola'
                  field='escolaOptions'
                  onChange={(e) => {
                    formApi.setValue('ano', '');
                    if (e) {
                      fetchEtapaEscola(e);
                      performUpdate({ escolaId: e.id })
                    }
                  }}
                  options={formInputData.escolaOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'ano-select'}
                  label='Ano'
                  field='ano'
                  onChange={(e) => {
                    formApi.setValue('periodo', '');
                    if (e) {
                      fetchPeriodo();
                      performUpdate({ ano: e.value });
                    }
                  }}
                  options={formInputData.anoOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'periodo-select'}
                  isLoading={state.isLoading}
                  label='Avaliação'
                  field='periodo'
                  onChange={(e) => {
                    formApi.setValue('etapaOptions', '');
                    if (e) {
                      performUpdate({ provas: e.value });
                      fetchAnoPeriodo(e.value, formApi.getState().values.ano);
                    }
                  }}
                  options={formInputData.periodoOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'etapaOptions-select'}
                  label='Série/Ano '
                  field='etapaOptions'
                  onChange={(e) => {
                    formApi.setValue('turmaOptions', '');
                    fetchTurma(e);
                  }}
                  options={formInputData.etapaOption}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'turmaOptions-select'}
                  label='Turma'
                  field='turmaOptions'
                  onChange={(e) => {
                    formApi.setValue('disciplinaOptions', '');
                    fetchDisciplinas(e);
                  }}
                  options={formInputData.turmaOptions}
                  required={true}
                />
              </Grid>

              <Grid item xs={12} md={3}>
                <InputSelect
                  key={'disciplinaOptions-select'}
                  isLoading={state.isLoading}
                  label='Área do Conhecimento'
                  field='disciplinaOptions'
                  options={formInputData.disciplinaOptions}
                  required={true}
                />
              </Grid>

              <Grid
                item xs={12} md={3}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  ...(!restrictAcess && {
                    justifyContent: 'end',
                    padding: '5px'
                  })
                }}>
                <button
                  id='submit-from'
                  style={{
                    color: 'white',
                    backgroundColor: props.theme.primary,
                    border: 'none',
                    fontSize: '16px',
                    fontWeight: '600',
                    textAlign: 'center',
                    cursor: 'pointer',
                    borderRadius: '15px',
                    boxShadow: '2px 4px 5px rgba(58, 58, 58, 0.25)',
                    letterSpacing: '1px',
                    padding: '4px 16px',
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'center',
                    marginLeft: '10px',
                  }}
                  onClick={(e) => { submitForm(e) }}
                >
                  Gerar Relatório
                </button>
              </Grid>
            </Grid>
          </Form>

          <div style={{
            background: '#bebebe',
            width: '100%',
            height: '1px',
            marginTop: '1rem'
          }} />

          {state.isLoadingAlunos ? (
            <div
              style={{
                width: '100%',
                height: `100%`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginTop: '1rem',
              }}
            >
              <img src={get(props.theme, "loadingGif")} alt="loading" style={{ height: '50px' }} />
            </div>) : (
            formInputData.alunoOptions
            && formInputData.alunoOptions.length > 0 && (
              <Grid style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'end',
                marginTop: '1rem'
              }}>
                <i className='fa fa-search' aria-hidden='true'
                  style={{
                    marginRight: '8px',
                    color: 'rgb(154, 154, 154)',
                    fontSize: '24px'
                  }}
                />
                <input
                  key={'input-search'}
                  placeholder='  Filtrar...'
                  onChange={(e) => setInputSearch((e.target.value).toUpperCase())}
                  style={{
                    border: '1px solid rgb(190, 190, 190)',
                    borderRadius: '8px',
                    padding: '3px',
                    width: '300px',
                    fontSize: '16px'
                  }}
                />
              </Grid>
            ))}

          <Grid item xs={12} style={{
            marginTop: '1rem',
            width: '100%',
            height: 'auto',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between'
          }} >
            {formInputData.alunoOptions && (
              formInputData.alunoOptions.filter((e) => e.label.toUpperCase().includes(inputSearch)).map((e) => (
                <Grid item style={{
                  display: 'flex',
                  justifyContent: 'center',
                  width: '49%'
                }}>
                  <button
                    key={e.idn}
                    id={e.idn}
                    style={{
                      width: '100%',
                      padding: '4px 16px',
                      height: '40px',
                      marginBottom: '20px',
                      justifyContent: 'flex-start',
                      border: 'none',
                      borderRadius: '4px',
                      fontSize: '14px',
                      backgound: 'transparent',
                      backgroundColor: '#DFDFDF',
                      border: isSelectedButton(e.idn) ? '2px solid #007bff' : 'none',
                    }}
                    onClick={() => {
                      handleClickButtonStudent(e.idn, e.label)
                    }}
                  >
                    <div
                      style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}
                    >
                      <>{e.cd_inst}- </>
                      <>{e.label} </>
                      <i className='fas fa-chevron-right black' />
                    </div>
                  </button>
                </Grid>
              ))
            )}
            {mustShowAllButton && formInputData.alunoOptions && (
              <div style={{ marginLeft: 'auto' }}>
                <Typography>
                  <Link to='' onClick={(e) => {
                    e.preventDefault();
                    setInputSearch('')
                  }}>
                    Mostrar todos
                  </Link>
                </Typography>
              </div>
            )}
          </Grid>
        </div>)}
    </>
  )
}

FiltersPageStudentAvaliaMt.contextType = FilterRelatorioContext;
export default withTheme(FiltersPageStudentAvaliaMt);
